import React from 'react';
import { useAppSync } from '../contexts/AppSyncContext';
import { AlertTriangle, RefreshCw, Clock, X } from 'lucide-react';
import { Button } from './ui/button';

export const TimeCheckAlert = () => {
  const { isTimeSynced, showTimeWarning, timeDiff, serverTime, dismissTimeWarning, retryTimeCheck } = useAppSync();

  // Don't show anything if time is synced or warning dismissed
  if (isTimeSynced || !showTimeWarning) {
    return null;
  }

  const diffMinutes = Math.round(timeDiff / 60000);
  const diffHours = Math.round(timeDiff / 3600000);

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="bg-white rounded-xl shadow-2xl border-2 border-orange-300 overflow-hidden">
        {/* Header */}
        <div className="bg-orange-50 px-4 py-3 flex items-center justify-between border-b border-orange-200">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center">
              <AlertTriangle className="h-4 w-4 text-orange-600" />
            </div>
            <span className="font-semibold text-orange-800">Date/Heure incorrecte</span>
          </div>
          <button 
            onClick={dismissTimeWarning}
            className="p-1 hover:bg-orange-100 rounded-full transition-colors"
          >
            <X className="h-4 w-4 text-orange-600" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-3">
          <p className="text-sm text-slate-600">
            L'heure de votre appareil est décalée de{' '}
            <span className="font-bold text-orange-700">
              {diffHours > 1 ? `${diffHours} heures` : `${diffMinutes} minutes`}
            </span>
            . Cela peut causer des problèmes de synchronisation.
          </p>

          <div className="flex items-center gap-2 text-xs text-slate-500 bg-slate-50 px-3 py-2 rounded-lg">
            <Clock className="h-3.5 w-3.5" />
            <span>Heure serveur: {serverTime ? new Date(serverTime).toLocaleString('fr-FR') : '...'}</span>
          </div>

          <div className="flex gap-2">
            <Button 
              onClick={retryTimeCheck}
              variant="outline"
              size="sm"
              className="flex-1"
            >
              <RefreshCw className="h-3.5 w-3.5 mr-1.5" />
              Vérifier
            </Button>
            <Button 
              onClick={dismissTimeWarning}
              size="sm"
              className="flex-1 bg-orange-500 hover:bg-orange-600"
            >
              Ignorer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeCheckAlert;
